<template>
    <form :action="action" method="get" class="buy-energy__form" :target="target">
        <div class="buy-energy__inputs">
            <div class="buy-energy__zipcity">
                <ZipCityWithLabel :label="zipCityLabel" :showLabel="false" @change="updateZipCity" />
            </div>
            <div class="buy-energy__amount">
                <InputWithLabel :label="amountLabel" :showLabel="false" type="number" :postfix="units" @change="updateAmount" />
            </div>
        </div>
        <button type="submit" class="buy-energy__submit" :data-product="product">{{buttontext}}</button>

        <input type="hidden" name="m" ref="amount" />
        <input type="hidden" name="zip" ref="zipcode" />
        <input type="hidden" name="city" ref="city" />
    </form>
</template>

<script>
    export default {
        props: {
            action: {
                type: String,
                required: true
            },
            target: {
                type: String,
                required: true
            },
            product: {
                type: String,
                required: true
            },
            zipCityLabel: {
                type: String,
                required: true
            },
            amountLabel: {
                type: String,
                required: true
            },
            units: {
                type: String,
                required: true
            },
            buttontext: {
                type: String,
                required: true
            }
        },
        methods: {
            updateZipCity(newVal) {
                this.$refs.zipcode.value = newVal.zipcode;
                this.$refs.city.value = newVal.city;
            },
            updateAmount(newVal) {
                this.$refs.amount.value = newVal;
            }
        }
    };
</script>